import axios from 'axios'
import { COMMISSIONS_ENDPOINT } from '../../../common/endpoints'

export async function getListCommissions({ search, cancelToken }) {
    try {
        const {data: { data }} = await axios.get(`${COMMISSIONS_ENDPOINT}${search}`, {cancelToken});
                
        return data;
    } catch (error) {
        console.log(`Error getListCommissions `, error)
        return error;
    }
    
}
